(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/helpers/normalize-team.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/helpers/normalize-team.js');
"use strict";


const normalizeTeam = teamData => teamData;
setGlobal('svs.components.marketplaceCompetition.services.helpers.normalizeTeam', normalizeTeam);

 })(window);